import config from '../../../config';
import Request from '../../Request';

export default function show(id, onSuccess, onFailure) {
  return Request.get(`${config.apiUrl}/orders/${id}`, onSuccess, onFailure);
}